import React from "react";

const ProfileHeader = ({ username, fullname, styles }) => {
    return(
        <div className={styles.ProfileHeader}>
            <div className={styles.avatarContainer}>
                <div className={styles.avatar}>
                    {username.charAt(0).toUpperCase()}
                </div>
            </div>
            <h2 className={styles.welcomeText}>Welcome, {fullname}!</h2>
        </div>
    );
}

export default ProfileHeader;